import { Component, EventEmitter, Output } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../../cfet-core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-customer-ineligibility-utf',
    templateUrl: './customer-ineligibility-utf.component.html',
    styleUrls: ['./customer-ineligibility-utf.component.scss'],
    standalone: false
})
export class CustomerIneligibilityUtfComponent extends CfetBaseComponent {

  urlNav = '';
  url: any;
  @Output() checkJobRole = new EventEmitter<any>();
  @Output() isRoleSelected = new EventEmitter<any>();
  @Output() progressTrackerEvent = new EventEmitter<any>();
  constructor(private router: Router) { super(); }

  shopPlansDevices (event) {
    if (event.keyCode === 13 || event.key === 'Enter' || event.type === 'click') {
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.urlNav = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.urlNav && this.urlNav.indexOf('?') === -1) {
          this.redirectToPageUrl(this.urlNav + '?fnStatus=ineligible');
        } else {
          this.redirectToPageUrl(this.urlNav + '&fnStatus=ineligible');
        }
      } else {
        // Redirect to the plp page
        const urlPlpNav = environment.plp_page;
        this.redirectToPageUrl(urlPlpNav + '?fnStatus=ineligible');
      }
    }
  }

  cancelCreation (event) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrlFn(encodeURIComponent(this.url + '?fnStatus=ineligible'));
        } else {
          this.redirectUrlFn(encodeURIComponent(this.url + '&fnStatus=ineligible'));
        }
      } else {
        // Redirect to plpPage
        const url = environment.plp_page;
        this.redirectUrlFn(encodeURIComponent(url + '&fnStatus=ineligible'));
      }
      sessionStorage.clear();
      this.isRoleSelected.emit(false);
      this.progressTrackerEvent.emit('roleDetails');
    }
  }

  redirectUrlFn(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

  goBack(event) {
    if ( event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
          this.redirecturl(this.cfetNavLinks.utf_header_links.check_eligibility_link);

      }
    }
  redirecturl(url) {
    window.location.href = url;
  }
  redirectToPageUrl (url) {
    window.location.href = url;
  }

}
